import React from 'react';
import GlobalContext from '../../GlobalContext';
import QuoteRequestForm, { BrochureBtn, ImgRender } from '../../BFComponents';

const CanonDRF120 = () => {
    const paths = GlobalContext().paths;
    const pictures = paths.pictures;

    return (
        <div className="container">
            <div className="row justify-content-end">
                <div className="col-md-4 align-self-end">
                    <div className="d-flex justify-content-end">
                        <img id="canon-red-img" src={pictures + "canon-logo-red.svg"}></img></div>
                    <img src={pictures + "imageformulaf120.svg"}></img>
                </div>
            </div>
            <span className="display-4">Office Document Scanner</span>
            <div id="drc-banner-div">
                <ImgRender width={100} image={"drf120main.jpg"} />
            </div>
            <div>
                <strong className="drc225blue">imageFORMULA DR-F120 Office Document Scanner<br /></strong>
            Deliver versatility to the workplace or home office with the imageFORMULA DR-F120
document scanner. With a sleek design that combines a flatbed with an automatic
feeder, the DR-F120 scanner is simple to use, bringing high-quality imaging,
flexibility, easy document processing—and even—elegance to any desk space</div>
            <div className="row">
                <div className="col-md-6">
                    <strong className="drc225blue">Wide Range of Uses.<br /></strong>
                The DR-F120 scanner provides a versatile scanning solution
to areas such as education, healthcare, manufacturing,
construction, information and data processing services,
and others that require both batch scanning and scanning
of various media formats to tackle different job tasks. With
the bundled software, users can access various scan modes,
including connection to cloud-based services,* so documents
can be uploaded and shared effortlessly. A variety of built-in
capabilities offers users easy-to-use scanning features,
making it an optimal choice for converting documents into
editable electronic files, PDF creation, document organization,
as well as other useful functions
                <strong className="drc225blue"><br />Versatile, Flexible, and Adaptable<br /></strong>

                    The DR-F120 scanner offers total adaptability, capable of handling
a wide range of document types through its incorporation of both
an Automatic Document Feeder (ADF) and flatbed. With the ability
to hold up to 50 sheets, the ADF can scan thick, thin, or long
documents, and the scanner can automatically detect color, page
size, and orientation of text in mixed batches. To further support
batch scanning, the scanner has features to help minimize jams
and double-feeds. Alternatively, the flatbed can help users handle
smaller scanning tasks for greater flexibility. The flatbed can handle
up to legal-sized documents as well as different types of media
formats, such as books, magazines, plastic or embossed cards,
and fragile documents, and convert these to a digital format for
easy office or personal organization and sharing. Through the
DR-F120 scanner’s versatility, work efficiency and productivity
can be greatly improved.
</div>
                <div className="col-md-6">
                    <QuoteRequestForm source={window.location} />
                    <BrochureBtn brochure={"SCANNER--CANON DR-F120 Document Scanner Brochure.pdf"} />

                    <strong className="drc225blue">Simple to Use<br /></strong>
                The DR-F120 scanner was designed with the user in mind.
Its simplicity is exemplified by its user-friendly control panel
for one-touch job operations, such as start and stop scanning,
copying, filing, and e-mailing documents. It can also scan
several documents at once, regardless of size and/or color,
thereby enhancing daily productivity and efficiency. Additionally,
the DR-F120 scanner allows the scanning of up to 20 pages/36
images per minute, in black and white, grayscale, or color, while
processing up to 800 documents per day for quick paper output.
<strong className="drc225blue">                        <br />High Quality Imaging<br /></strong>

When it comes to handling daily paperwork, accurate information
capture helps to save time and minimize manual steps involved
with business processes or paper organization at home. The
DR-F120 scanner delivers features
to enhance text legibility, including
light-colored text on light-colored
backgrounds. For maximum image
quality, this scanner can also help
to straighten and remove shadows
from scanned images. With the
DR-F120 scanner, document
details can be captured correctly.
                    </div>
            </div>
        </div>
    )
}


export default CanonDRF120;